import React, {useRef} from "react";
import {observer} from "mobx-react";
import appStore, { BreadcrumbsDI } from "../stores/AppStore";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import style from "./SubHeader.module.css";
import Breadcrumbs from "../breadcrumbs/Breadcrumbs";


interface SubHeaderPropsDI {
  links: Array<BreadcrumbsDI>;
  showBackgroundImage: boolean;
}

const SubHeader: React.FC<SubHeaderPropsDI> = (props) => {
let navigate = useNavigate();

  const {t} = useTranslation();

  const inputRef = useRef<HTMLInputElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const menuItems = appStore.header.links;

  return (
    <React.Fragment>
      {props.showBackgroundImage ? (
        <div
          className={style.withImage}
          style={{
            top: appStore.isMobileResolution ? 51 : 0,
          }}
        >
          <div className={style.lessons_list_wrapper}>
            <div className={`${style.lessons_list} listwithImage`}>
              <Breadcrumbs links={props.links} withImage={true}/>
              <h4>{t("Lesson-search-header")}</h4>
            </div>
          </div>
          <div></div>
        </div>
      ) : (
        <Breadcrumbs links={props.links} />
      )}
    </React.Fragment>
  );
};

export default observer(SubHeader);
